import { ROLES } from './constants';

/** Roles that use the operator Home shell, not Tenant Management / Home Designer / Event System. */
export const OPERATOR_SHELL_ROLES = new Set([
  ROLES.OPERATOR,
  ROLES.VIEWER,
  ROLES.SITE_ADMIN,
]);

export function isOperatorShellRole(role) {
  return OPERATOR_SHELL_ROLES.has(String(role || ''));
}

const HOME_EDITOR_ROLES = new Set([
  ROLES.ADMIN,
  ROLES.SUPERADMIN,
  ROLES.TENANT_ADMIN,
]);

/** Operators may rearrange Home only when Can Configure is on. Admins always can. */
export function canEditHomeButtons({
  role,
  permissions = {},
  dealerActive = false,
} = {}) {
  if (dealerActive) return true;
  if (HOME_EDITOR_ROLES.has(String(role || ''))) return true;
  if (isOperatorShellRole(role)) return Boolean(permissions?.canConfigure);
  return true;
}

/** Home, launcher settings, and My Reports — any signed-in tenant user. */
export const HOME_ALLOWED_ROLES = [
  ROLES.ADMIN,
  ROLES.SUPERADMIN,
  ROLES.TENANT_ADMIN,
  ROLES.OPERATOR,
  ROLES.VIEWER,
  ROLES.SITE_ADMIN,
  ROLES.USER,
  ROLES.RESPONDER,
  ROLES.DEMO_USER,
  ROLES.SUPPORT_USER,
  ROLES.OVERSEER,
];

/**
 * Prefer the Firestore profile when it is already an operator-class role so a
 * just-demoted user does not keep the admin shell until their ID token refreshes.
 */
export function resolveEffectiveRole(claimsRole, firestoreRole) {
  if (isOperatorShellRole(firestoreRole)) return firestoreRole;
  return claimsRole || firestoreRole || null;
}

/**
 * True only when both the ID-token role and the loaded user-profile role exist
 * and differ. A failed profile load is not a mismatch. Tenant membership roles
 * are a separate record and are not compared here.
 */
export function claimsDisagreeWithProfile(claimsRole, profile) {
  const profileRole = profile?.role;
  if (!claimsRole || !profileRole) return false;
  return claimsRole !== profileRole;
}
